
/* ----- Middlewares ----- */
import auth from "@/middleware/axiosInterceptor";
import guest from "@/middleware/guest";

/* ----- Routes ----- */
import authenticationRoutes from "@/router/routes/authentication-routes";
import clientsRoutes from "@/router/routes/clients-routes";
import contractsRoutes from "@/router/routes/contracts-routes";
import demandsRoutes from "@/router/routes/demands-routes";
import devicesRoutes from "@/router/routes/devices-routes";
import techniciansRoutes from "@/router/routes/technicians-routes";
import documentsRoutes from "@/router/routes/documents-routes";
import productsRoutes from "@/router/routes/products-routes";
import billsRoutes from "@/router/routes/bills-routes";
import interventionsRoutes from "@/router/routes/interventions-routes";
import planningRoutes from "@/router/routes/planning-routes";

/* ----- Layout ----- */
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";
import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";

/* ----- Views ----- */
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import UserProfile from "@/pages/Dashboard/Examples/UserProfile.vue";
import Stats from "@/pages/Stats/Stats";

/* ----- ----- ----- ----- ----- ----- ----- */

const adminPublicRoutes = [
    ...authenticationRoutes
].map(route => {
    return {...route, meta: { ...route.meta, middleware: guest }}
})

const adminAuthRoutes = [
    {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            route: {
                label: 'Tableau de bord'
            }
        }
    },
    {
        path: 'profile',
        name: "Profile",
        component: UserProfile,
        meta: {
            route: {
                label: 'Profil'
            }
        }
    },
    {
        path: 'stats',
        name: 'Stats',
        component: Stats,
        meta: {
            route: {
                label: 'Statistiques'
            }
        }
    },
    ...clientsRoutes,
    ...contractsRoutes,
    ...demandsRoutes,
    ...devicesRoutes,
    ...techniciansRoutes,
    ...documentsRoutes,
    ...productsRoutes,
    ...billsRoutes,
    ...interventionsRoutes,
    ...planningRoutes
].map(route => {
    return {...route, meta: { ...route.meta, middleware: auth }}
})

const routes = [
    {
        path: "/admin",
        redirect: "/admin/dashboard",
    },
    {
        path: "/admin",
        component: AuthLayout,
        meta: { middleware: guest },
        children: adminPublicRoutes
    },
    {
        path: "/admin",
        component: DashboardLayout,
        meta: { middleware: auth },
        children: adminAuthRoutes
    },
]
export default routes